@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <div [formGroup]="activeQuestion" class="info-page-settings">
    <div class="info-page-settings__input-containers">
      <empathy-min-view-time-setting [activeQuestion]="activeQuestion" [showBorder]="false"></empathy-min-view-time-setting>
    </div>

    <empathy-media-settings [activeQuestion]="activeQuestion"></empathy-media-settings>
  </div>
}
